import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { UBC_COMMERCIAL_LIST_STATE_NAME } from './contants';
import { UBCCommercialListEffects } from './ubc-commercial-list.effects';
import { ubcCommercialListReducer } from './ubc-commercial-list.reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([UBCCommercialListEffects]),
    StoreModule.forFeature(
      UBC_COMMERCIAL_LIST_STATE_NAME,
      ubcCommercialListReducer,
    ),
  ],
})
export class UBCCommercialListModule {}
